<wl-modal
  (closeModal)="dismissModal()"
  [modalTitle]="rendering?.fields?.ModalAdjustCalculationTitle?.value"
>
  <ng-template wlModalBody>
    <div
      sc-placeholder
      name="offer-calculate-modal"
      [rendering]="rendering"
      [inputs]="{
        isInModal: true,
      }"
    ></div>
  </ng-template>
</wl-modal>
